import { Box, Button, CardMedia, useMediaQuery } from "@mui/material";
import MapComponent from "./map.component";
import { useState } from 'react';
import MobileModal from "./mobile-modal.component";
import { useToursContext } from '../../contexts/tour-context';
import { useTourById } from "../../services/hooks/useTours";
import TourDrawer from './tour-drawer/tour-drawer-scene.component';
import WelcomeComponent from './welcome-container.component';
import { envAssets } from '../../environment';
import { Trans } from "@lingui/macro";

export default function MapScene() {
    const [mobileModal, setMobileModal] = useState(false)
    const matches = useMediaQuery('(min-width:600px)');
    const { mapHeight, isTourDrawerOpened, clickedTourId } = useToursContext();
    const { clickedTourData } = useTourById(clickedTourId);

    let isDev = process.env.REACT_APP_ENV === undefined || process.env.REACT_APP_ENV === 'staging'
    const WIDTH = { xs: '100%', sm: '50%', md: '55%', lg: '65%' };
    const WIDTH_MODAL = { xs: '100%', sm: '50%', md: '40%', lg: '30%' };

    function mobileMapImage() {
        let pathToImage = '/wp-content/themes/hello-elementor-child/assets/images/';
        switch (window.location.hostname) {
            case 'winetour-northeast.bg':
                return isDev ? envAssets('images/winetour-map-mockup-northeast.jpg') : pathToImage + 'winetour-map-mockup-northeast.jpg';
            case 'winetour-southwest.bg':
                return isDev ? envAssets('images/winetour-map-mockup-southwest.jpg') : pathToImage + 'winetour-map-mockup-southwest.jpg';
            case 'winetour-southeast.bg':
                return isDev ? envAssets('images/winetour-map-mockup-southeast.jpg') : pathToImage + 'winetour-map-mockup-southeast.jpg';
            case 'winetour-northwest.bg':
                return isDev ? envAssets('images/winetour-map-mockup-northwest.jpg') : pathToImage + 'winetour-map-mockup-northwest.jpg';
            default:
                return isDev ? envAssets('images/winetour-map-mockup-northeast.jpg') : pathToImage + 'winetour-map-mockup-northeast.jpg';
        }
    }

    let mobileImage = mobileMapImage();

    return (
        <>
            {matches ?
                <Box height={mapHeight} ml={{ sm: 2, md: 5 }} mr={{ sm: 0, md: 2, lg: 3, xl: 5 }} style={{ display: 'flex' }}>
                    <Box flex={1} flexBasis={WIDTH}>
                        <MapComponent />
                    </Box>
                    <Box flex={1} flexBasis={WIDTH_MODAL}>
                        {(isTourDrawerOpened && matches) ?
                            <TourDrawer clickedTourData={clickedTourData} />
                            :
                            <WelcomeComponent />
                        }
                    </Box>
                </Box>
                :
                <Box height={mapHeight}>
                    <>
                        <CardMedia
                            width={'100%'} height={'100%'}
                            loading="lazy"
                            component="img"
                            sx={{ objectFit: 'cover' }}
                            image={mobileImage}
                            alt={'logo'}
                        />
                        <Button
                            onClick={() => setMobileModal(true)}
                            sx={{
                                width: '80%',
                                position: 'absolute', bottom: '10%',
                                left: '50%', right: '50%',
                                transform: 'translate(-50%, -50%)',
                                bgcolor: '#439854', ':hover': { bgcolor: '#397E46' }, color: 'white', py: 1, fontSize: 18
                            }} variant="contained">
                            <Trans>Интерактивна карта</Trans>
                        </Button>
                    </>
                    <MobileModal mobileModal={mobileModal} setMobileModal={setMobileModal} />
                </Box>
            }
        </>
    )
}